import {Component} from "@angular/core";
import {CarBrand} from "./brand/CarBrand";
import {environment} from "../../../../../../environments/environment";

/**
 * Created by Benoit Valkenberg on 16-12-17.
 */
@Component({
    selector: 'new-car-presentation',
    styleUrls: ['./presentation.scss'],
    templateUrl: './presentation.html'
})
export class NewCarPresentationComponent {

    public brands:Array<CarBrand>;

    ngOnInit(){
        this.brands = [];
        this.brands.push(
            new CarBrand("Renault",
            environment.clientUrl + "assets/img/brands/Renault.png",
                "Changeons de vie, changeons l'automobile.",
                "https://www.renault.lu/",
                "https://www.renault.lu/vehicules/configurez-un-modele"));
        this.brands.push(new CarBrand(
            "Suzuki",
            environment.clientUrl + "assets/img/brands/Suzuki.png",
            "Un mode de vie!",
            "https://suzuki.lu/fr",
            "http://configurateur.suzuki.fr"));
        this.brands.push(new CarBrand(
            "Dacia",
            environment.clientUrl + "assets/img/brands/Dacia.png",
            "Exigez plus, payez moins. Scandaleusement accessible.",
            "https://www.dacia.lu/",
            "https://www.dacia.lu/gamme-configurer.html"));
        this.brands.push(new CarBrand("Ligier",
            environment.clientUrl + "assets/img/brands/Ligier.png",
            "Freedom to move!",
            "http://www.ligier.fr/",
            "http://www.ligier.fr/configurateur-voiture-sans-permis"));
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/new-car/presentation/presentation.ts